'use strict'

import YouTubePlayer from 'youtube-player'

export default class Popup {
  constructor(el) {
    const html = document.querySelector('html')
    const headerBanner = document.querySelector('.global-header__banner')
    const header = document.querySelector('.global-header')
    const headersArray = []
    const stylesArray = [html]
    if (headerBanner != undefined) {
      headersArray.push(headerBanner)
      stylesArray.push(headerBanner)
    }
    if (header != undefined) {
      headersArray.push(header)
      stylesArray.push(header)
    }
    const getScrollWidth = function () {
      const windowWidth1 = document.documentElement.clientWidth
      const windowWidth2 = window.innerWidth
      const scrollWidth = windowWidth2 - windowWidth1

      return scrollWidth
    }
    const createPopup = function (src, type) {
      const popup = document.createElement('div')
      const popupWrapper = document.createElement('div')
      const popupOverlay = document.createElement('div')
      const popupContent = document.createElement('div')
      const popupImage = document.createElement('img')
      const popupVideo = document.createElement('div')
      const videoPlayer = document.createElement('div')
      const popupClose = document.createElement('button')
      const popupCloseIcon = document.createElement('i')
      const scrollWidth = getScrollWidth()

      popup.classList.add('popup')
      popupWrapper.classList.add('popup-wrapper')
      popupOverlay.classList.add('popup-overlay')
      popupContent.classList.add('popup-content')
      popupClose.classList.add('popup-close')
      popupClose.type = 'button'
      popupVideo.classList.add('popup-video')
      videoPlayer.id = 'video-player'

      document.body.appendChild(popup)
      popup.appendChild(popupWrapper)
      popupWrapper.appendChild(popupOverlay)
      popupWrapper.appendChild(popupContent)
      popupContent.appendChild(popupClose)
      popupClose.appendChild(popupCloseIcon)

      if (type == 'image') {
        popupImage.src = src
        popupContent.appendChild(popupImage)
      } else {
        popupContent.appendChild(popupVideo)
        popupVideo.appendChild(videoPlayer)

        const player = YouTubePlayer('video-player', {
          videoId: src,
          host: 'https://www.youtube-nocookie.com',
          playerVars: {
            origin: window.location.host
          }
        })
        player.playVideo()
      }

      setTimeout(() => {
        html.classList.add('lock-scroll')
        html.style.marginRight = `${scrollWidth}px`
        const changeWidth = headersArray.forEach(obj => {
          obj.style.width = `calc(100% - ${scrollWidth}px)`
        })
      }, 10)

      const removePopup = [popupOverlay, popupClose].forEach(obj => {
        obj.addEventListener('click', function () {
          popupWrapper.classList.add('fade-out')
          setTimeout(() => {
            html.classList.remove('lock-scroll')
            const removeStyles = stylesArray.forEach(obj => {
              obj.removeAttribute('style')
            })
            const player = YouTubePlayer('video-player', {
              videoId: src
            })
            player.stopVideo()
            popup.remove()
          }, 400)
        })
      })
    }

    el.addEventListener('click', function (event) {
      event.preventDefault()

      const img = this.dataset.image
      const video = this.dataset.video
      const src = video ? video : img
      const type = video ? 'video' : 'image'

      createPopup(src, type)
    })
  }
}
